<template>
  <div class="eemo-page-shell" style="background: white;">
  <div class="tnc-body">
    <h5>Booking terms and conditions</h5>
    <p>Last updated 1 October 2026.</p>
    <p>
      These terms apply when you reserve a table through Show Me The Menu, including a reservation made on Google
      with Reserve with Google. By making the reservation, you agree to them.
    </p>

    <h6>1. The restaurant</h6>
    <p>
      The reservation is with the restaurant you select, not with Show Me The Menu.
      Show Me The Menu is a brand of <b>Borium Studio Limited</b>, Unit 68, Trident Court,
      1 Oakcroft Road, Chessington KT9 1BD, United Kingdom. It provides the booking pages,
      emails, and the link that passes a Google reservation to the restaurant.
    </p>
    <p>
      The restaurant decides its times, party sizes, seating choices and whether it can take the booking.
      House rules shown by that restaurant also apply.
    </p>

    <h6>2. Making a reservation</h6>
    <p>
      You must give a name and a way to contact you, and the number of adults, children and toddlers who will come.
      The details must be accurate. The restaurant may refuse a party that is larger than the booking, or that arrives
      without the booking.
    </p>
    <p>
      A time shown as available can be confirmed immediately. That confirmation is from the restaurant.
      Where a restaurant offers more than one seating choice, the choice you select is part of the booking.
    </p>

    <h6>3. Google reservations</h6>
    <p>
      If you book on Google, Google sends the reservation to the restaurant through Show Me The Menu.
      The restaurant’s confirmation, a later cancellation, and a no-show are sent back to Google.
      Google’s own emails about that booking come from Google. A message from the restaurant is sent by the restaurant’s email.
    </p>
    <p>
      To change the date or time of a Google reservation, change or cancel it in Google and make a new booking if you still need a table.
      The restaurant does not move a confirmed Google reservation to a different time.
    </p>

    <h6>4. Cancellation and no-show</h6>
    <p>
      You may cancel using the link in your confirmation where one is provided, or through Google if you booked there.
      The restaurant may also cancel, and may include a short message in its cancellation email.
    </p>
    <p>
      Please cancel if you cannot come. If you do not arrive, the restaurant may mark the booking as a no-show.
      For a Google reservation, that no-show is also sent to Google.
    </p>

    <h6>5. Your visit</h6>
    <p>
      A reservation holds a time. It is not a guarantee of a particular table unless the confirmation names one.
      The restaurant may change the table. Please arrive on time. The restaurant may release the table if you are late.
    </p>

    <h6>6. Problems</h6>
    <p>
      Questions about the meal, the time, or a cancellation are for the restaurant.
      Show Me The Menu hosts the booking record and does not decide whether the restaurant accepts, cancels, or marks a no-show.
      If you need help with a booking made through Show Me The Menu, use the
      <router-link to="/support/booking">booking support form</router-link>.
    </p>
    <p>
      Nothing in these terms limits liability for death or personal injury caused by negligence, or any right you have by law
      that cannot be limited.
    </p>
    <p>
      These terms are governed by the laws of England and Wales.
    </p>
  </div>
  </div>
</template>

<script>
export default {
  name: "BookingTnC"
}
</script>

<style scoped>
.tnc-body {
  text-align: left;
  padding: 10px 15px 20px 15px;
  font-size: 14px;
  color: #333;
  line-height: 1.45;
  max-width: 760px;
  margin: 0 auto;
}
.tnc-body h5 {
  font-weight: 700;
  margin-bottom: 12px;
}
.tnc-body h6 {
  font-weight: 700;
  margin-top: 18px;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingTnC.vue